import { render, staticRenderFns } from "./ViewClaims.vue?vue&type=template&id=59018ade"
import script from "./ViewClaims.vue?vue&type=script&lang=js"
export * from "./ViewClaims.vue?vue&type=script&lang=js"
import style0 from "./ViewClaims.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports